import { MOCK_ACCOUNT_MANAGERS } from "../data/mockAccountManagers";
import { MOCK_ACCOUNT_MANAGER_PROFILES } from "../data/mockAccountManagerProfiles";
import type { AccountManagerProfile } from "../types";

function defaultProfileFields(
  manager: (typeof MOCK_ACCOUNT_MANAGERS)[number],
): AccountManagerProfile {
  return {
    ...manager,
    status: "active",
    assignedCustomers: [],
    recentActivity: [],
  };
}

export function getAccountManagerById(
  managerId: string,
): (typeof MOCK_ACCOUNT_MANAGERS)[number] | undefined {
  return MOCK_ACCOUNT_MANAGERS.find((manager) => manager.id === managerId);
}

export function getAccountManagerProfile(
  managerId: string,
): AccountManagerProfile | undefined {
  const manager = getAccountManagerById(managerId);
  if (!manager) {
    return undefined;
  }

  const extra = MOCK_ACCOUNT_MANAGER_PROFILES[managerId];
  if (!extra) {
    return defaultProfileFields(manager);
  }

  return { ...manager, ...extra };
}
